const it = {
  nav: {
    why: 'PERCHÉ',
    when: 'QUANDO',
    what: 'COSA',
    situation: 'SITUATION',
    video: 'VIDEO',
    social: 'SOCIAL',
    about: 'CHI SONO',
    contact: 'CONTATTI',
    menu: 'MENU',
    close: 'CHIUDI',
  },
  hero: {
    meta: 'ALBERTO SCOTTA — L’INGEGNERE CREATIVO',
    scroll: 'SCORRI',
  },
  payoff: {
    lines: ['C’È', 'SEMPRE', 'UNA SOLUZIONE.'],
  },
  verbs: [
    { id: 'raccontare', word: 'RACCONTARE.', def: 'Storie di persone, eventi, memorie.' },
    { id: 'emozionare', word: 'EMOZIONARE.', def: 'Aneddoti · Ricordi · Esperienze' },
    { id: 'convincere', word: 'CONVINCERE.', def: 'Argomentazioni, framing, persuasione.' },
  ],
  marquee: ['RACCONTARE', 'EMOZIONARE', 'CONVINCERE', 'RISOLVERE', "THERE'S ALWAYS A SOLUTION."],
  why: {
    kicker: 'PERCHÉ',
    lines: ['HAI UNA', 'OPPORTUNITÀ.'],
    extra: ['SEI PRONTO', 'A COGLIERLA?'],
    body: 'Comunichiamo continuamente, anche quando non ce ne accorgiamo. Una parola, un silenzio, una domanda fatta bene possono cambiare una relazione, una trattativa o un’opportunità. La comunicazione non serve solo a spiegarsi: serve a capire, emozionare e convincere.',
    goal: ['L’obiettivo?', 'Comunicare meglio', ['dell’', '87,44%', ' delle persone.']],
    note: 'Il numero è discutibile. Il vantaggio, molto meno.',
  },
  bridge: {
    kicker: 'IL PUNTO DI PARTENZA',
    a: 'LA VITA NON CI PRESENTA MATERIE.',
    b: 'CI PRESENTA SITUAZIONI.',
    quote: 'Non pensiamo “adesso mi serve una tecnica di negoziazione”. Pensiamo: “devo convincere questa persona”.',
  },
  situations: {
    kicker: 'QUANDO',
    title: 'IN CHE SITUAZIONE SEI?',
    sub: 'PRIMA LA SITUAZIONE. POI GLI STRUMENTI.',
    hint: 'SCORRI',
    scenes: [
      {
        n: '01',
        lines: ['DEVI', 'SALIRE', 'SU UN PALCO.'],
        tags: ['Public speaking', 'Presentazioni', 'Storytelling'],
        size: 'big',
      },
      {
        n: '02',
        lines: ['DEVI', 'CONVINCERE', 'QUALCUNO.'],
        tags: ['Negoziazione', 'Comunicazione', 'Persuasione'],
        size: 'big',
      },
      {
        n: '03',
        lines: ['HAI', 'QUALCOSA', 'DA DIRE.'],
        extra: ['MA NON SAI', 'COME DIRLO.'],
        tags: ['Comunicazione', 'Storytelling'],
        size: 'big',
      },
      {
        n: '04',
        lines: ['LE PERSONE', 'NON REAGISCONO', 'COME TI ASPETTAVI.'],
        tags: ['Intelligenza emotiva', 'Relazioni', 'Comunicazione'],
        size: 'small',
      },
      {
        n: '05',
        lines: ['QUALCOSA', 'È ANDATO', 'STORTO.'],
        tags: ['Problem solving', 'Negoziazione', 'Situation'],
        size: 'big',
      },
    ],
  },
  invasion: {
    line: 'PRIMA LE SITUAZIONI. POI GLI STRUMENTI.',
  },
  whatwedo: {
    kicker: 'COSA',
    title: 'COSA POSSIAMO FARE INSIEME',
    rows: [
      {
        id: 'docenze',
        index: '01',
        label: 'DOCENZE',
        body: 'Per scuole, accademie, università, enti di formazione e organizzazioni. Non semplici lezioni frontali, ma quello che è più efficace:',
        chips: ['interazione', 'role playing', 'storie', 'esperimenti', 'domande', 'giochi', 'situazioni reali'],
      },
      {
        id: 'consulenze',
        index: '02',
        label: 'CONSULENZE',
        body: 'Percorsi personalizzati, costruiti intorno a:',
        chips: ['un obiettivo', 'un problema', 'una situazione', 'una presentazione', 'una negoziazione', 'una decisione', 'una comunicazione importante'],
      },
      {
        id: 'corsi',
        index: '03',
        label: 'CORSI',
        body: '',
        items: ['Comunicazione', 'Negoziazione', 'Intelligenza emotiva', 'Public Speaking', 'Storytelling', 'Problem Solving'],
      },
    ],
  },
  situation: {
    kicker: 'SITUATION',
    title: 'SITUATION',
    subtitle: 'IL GIOCO DI RUOLO DELLA VITA REALE',
    headlineA: 'QUI LE SITUAZIONI',
    headlineB: 'NON SI SPIEGANO.',
    headlineC: 'SI VIVONO.',
    intro: 'Un’esperienza pratica da vivere insieme. Alcune persone partecipano. Altre osservano. Poi ricostruiamo quello che è successo.',
    gives: ['UN RUOLO.', 'UN CONTESTO.', 'UN OBIETTIVO.', 'INFORMAZIONI CHE GLI ALTRI NON CONOSCONO.'],
    noScript: 'NESSUN COPIONE. Ognuno reagisce come reagirebbe nella vita reale.',
    cta: 'PROVA UNA SITUAZIONE',
    scene: {
      role: 'Sei uno degli ospiti.',
      context: 'Una cena, sei persone. Qualcuno afferma con sicurezza una cosa sbagliata su di te. Tutti si girano verso di te.',
      goal: 'Uscirne bene. Senza scenate, senza teatri.',
      prompt: 'COSA FAI?',
      options: [
        { key: 'A', text: 'Cambi argomento e fai finta di niente.' },
        { key: 'B', text: 'Rispondi secco, punto e a capo.' },
        { key: 'C', text: 'Prendi la battuta, la giri e racconti la versione vera.' },
      ],
    },
    result: {
      chosenLabel: 'HAI SCELTO',
      noRight: 'MA NON ESISTE LA SCELTA GIUSTA',
      q1: 'COSA VOLEVI OTTENERE?',
      q2: 'COSA HAI OTTENUTO DAVVERO?',
      body: 'Non cerchiamo sempre la risposta “giusta”. Scopriamo quali conseguenze producono scelte diverse. È un ambiente protetto nel quale puoi:',
      can: ['SBAGLIARE.', 'PROVARE.', 'CAMBIARE.', 'RIPROVARE.'],
      retry: 'INDIETRO',
    },
    areasLabel: 'SITUAZIONI DI VITA REALE SCELTE TRA:',
    areas: ['LAVORO', 'COPPIA', 'AMICI', 'SOCIAL', 'NEGOZIAZIONI', 'CONFLITTI', 'DENARO', 'IMPREVISTI', 'QUESTIONI LEGALI'],
    closeA: 'PERCHÉ NELLA VITA REALE NON SERVE AVERE RAGIONE.',
    closeB: 'CONTA CAPIRE LA SITUAZIONE E SAPERE COME RAGGIUNGERE I PROPRI OBIETTIVI.',
  },
  stories: {
    kicker: 'VIDEO',
    headline: ['OGNI COSA PUÒ', 'DIVENTARE', 'UNA STORIA.'],
    body: 'Sul mio canale racconto storie, come quelle che nascono da una maglia da calcio e portano a una persona, un luogo, un evento. Analizzo la comunicazione di personaggi pubblici, preparo guide pratiche e condivido consigli utili per comunicare meglio, ogni giorno.',
    topics: ['Storie', 'Analisi della comunicazione', 'Guide', 'Consigli utili'],
    watch: 'GUARDA IL CANALE',
  },
  words: {
    kicker: '05 — ANALISI DELLA COMUNICAZIONE',
    ghost: 'WORDS MATTER.',
    headline: ['LE PAROLE', 'NON SONO MAI', 'SOLO PAROLE.'],
    body: 'Analizzo interviste, conferenze stampa, discorsi, dichiarazioni, comunicazione mediatica. L’obiettivo non è giudicare la persona: usare casi reali per capire meglio.',
    items: ['parole', 'argomentazioni', 'framing', 'persuasione', 'errori comunicativi', 'fallacie', 'non verbale quando osservabile'],
  },
  about: {
    kicker: 'CHI SONO',
    lead: 'L’ingegnere che ha scelto di fare il creativo.',
    steps: [
      { id: 'ingegnere', word: 'INGEGNERE.', d: 'Politecnico di Torino. Ingegneria delle telecomunicazioni.' },
      { id: 'creativo', word: 'CREATIVO.', d: 'Deltatre: Head of UXD, poi Creative Director.' },
      { id: 'comunicatore', word: 'COMUNICATORE.', d: 'Oltre 20 anni presentando idee, concetti e prodotti.' },
      { id: 'storyteller', word: 'STORYTELLER.', d: 'Persone, eventi, luoghi, oggetti: ogni cosa ha una storia.' },
      { id: 'docente', word: 'DOCENTE.', d: 'Situazioni reali, role playing, giochi, domande.' },
      { id: 'creator', word: 'CREATOR.', d: 'Head of Football Manager ITA dal 1997. Contenuti che arrivano a milioni di fan.' },
      { id: 'panoz', word: 'PANOZ.', d: 'Alberto Scotta.' },
    ],
  },
  rooms: {
    kicker: 'ESPERIENZE',
    headline: ['SONO STATO', 'IN ALCUNE', 'STANZE INTERESSANTI.'],
    realities: ['UEFA', 'FIFA', 'CIO', 'FIFA Museum', 'THE FA', 'Football Manager', 'Now United', 'Accademia dello Sport', 'Sportitalia'],
    note: 'Attività, presentazioni e progetti.',
    seenOn: 'VISTO SU',
  },
  contact: {
    kicker: 'CONTATTI',
    lineA: 'LET’S FIND',
    lineB: 'A SOLUTION.',
    sub: 'TROVIAMO UNA SOLUZIONE.',
    cta: 'SCRIVIMI SU TELEGRAM',
    mail: 'MANDAMI UNA MAIL',
  },
  social: { kicker: 'SOCIAL' },
  footer: { rights: 'Alberto Scotta — PANOZ4U' },
};

export default it;
